import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import CategoriesMain from "../Components/Categories Resale/categoriesMain";
import AddCategories from "../Components/Categories Resale/addCategories";
import EditCategories from "../Components/Categories Resale/editCategories";
import AddSubCategories from "../Components/Categories Resale/addSubCategories";
import EditSubCategories from "../Components/Categories Resale/editSubCategory";
import ViewCategory from "../Components/Categories Resale/viewCategory";

const CategoriesRoutes = () => {
  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];

  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');
  return (
    <Routes>
      <Route path="/categories_resale" element={<CategoriesMain />}></Route>
      <Route path="/categories_resale/add" element={canAdd ? <AddCategories /> : <Navigate to="/categories" replace /> }></Route>
      <Route path="/categories_resale/edit/:id" element={canEdit ? <EditCategories /> : <Navigate to="/categories" replace />}></Route>
      <Route
        path="/categories_resale/:id/sub/add"
        element={<AddSubCategories />}
      ></Route>
      <Route
        path="/categories_resale/view/:id"
        element={<ViewCategory />}
      ></Route>
      <Route
        path="/categories_resale/view/sub/edit/:id"
        element={<EditSubCategories />}
      ></Route>
    </Routes>
  );
};

export default CategoriesRoutes;
